var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"center-vertical",staticStyle:{"flex-direction":"column","height":"300px"}},[_c('img',{attrs:{"src":_vm.img,"alt":""}}),_c('p',[_vm._v("页面消失了")])])
}
var staticRenderFns = []

export { render, staticRenderFns }